export default __webpack_public_path__ + "images/2a8498f6bf0152b33fd498b338383e59-lacrosse.png";